import { Routes } from '@angular/router';
import { GrundbuchmeldungSucheComponent } from './grundbuchmeldung-suche/grundbuchmeldung-suche.component';
import { GrundbuchmeldungListComponent } from './grundbuchmeldung-list/grundbuchmeldung-list.component';
import { GrundbuchmeldungDetailComponent } from './grundbuchmeldung-detail/grundbuchmeldung-detail.component';
import { PrintGrundbuchmeldungComponent } from './grundbuchmeldung-detail/print-grundbuchmeldung/print-grundbuchmeldung.component';
import { ErweiterungConfigResponse, PermissionResponse } from '../../core/base-api';
import { canActivateErweiterung } from '../../security/erweiterung.guard';
import { canActivateAuthorization } from '../../security/authorization.guard';
import { ZusatzangabenDetailComponent } from './grundbuchmeldung-detail/vertragsdaten/zusatzangaben-detail/zusatzangaben-detail.component';
import { HandelsangabenDetailComponent } from './grundbuchmeldung-detail/vertragsdaten/handelsangaben-detail/handelsangaben-detail.component';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;
import PermissionsEnum = PermissionResponse.PermissionsEnum;

export const GrundbuchmeldungRoutes: Routes = [
  {
    path: 'grundbuchmeldung',
    loadChildren: () => routes,
    providers: [ZusatzangabenDetailComponent, HandelsangabenDetailComponent]
  }
];

const routes: Routes = [
  {
    path: '',
    component: GrundbuchmeldungSucheComponent,
    canActivate: [canActivateErweiterung],
    data: {
      erweiterung: [ActiveErweiterungenEnum.MELDUNGEN_STANDARD, ActiveErweiterungenEnum.HANDAENDERUNGSMELDUNG],
      breadcrumb: 'grundbuchmeldung.search.breadcrumb',
      breadcrumbStatus: 'firstLevel'
    }
  },
  {
    path: 'list',
    component: GrundbuchmeldungListComponent,
    data: {
      breadcrumb: 'shared.breadcrumb.list',
      breadcrumbStatus: 'secondLevel'
    }
  },
  {
    path: 'detail/generatepdf',
    component: PrintGrundbuchmeldungComponent
  },
  {
    path: 'detail/generatertf',
    component: PrintGrundbuchmeldungComponent
  },
  {
    path: 'detail/:id',
    component: GrundbuchmeldungDetailComponent,
    canActivate: [canActivateAuthorization, canActivateErweiterung],
    data: {
      permissions: [PermissionsEnum.GRUNDBUCH_MELDUNGEN_REGISTER],
      erweiterung: [ActiveErweiterungenEnum.MELDUNGEN_STANDARD, ActiveErweiterungenEnum.HANDAENDERUNGSMELDUNG]
    }
  },
  {
    path: 'detail',
    redirectTo: 'detail/'
  }
];
